import { type FC, useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { useNotifications } from '../../../modules/hooks';
import { useAccessCodes } from '../../Dashboards/TemporaryAccessCodes/useAccessCodes';

interface ViewCodeModalProps {
  show: boolean;
  uuid?: string;
  handleClose: () => void;
}

/** Reveals an access code's PIN via the dedicated `/code` route. */
export const ViewCodeModal: FC<ViewCodeModalProps> = ({ show, uuid, handleClose }) => {
  const { setSimpleToasts } = useNotifications()!;
  const accessCodes = useAccessCodes();
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !uuid) return;
    setPin('');
    setLoading(true);
    accessCodes
      .revealCode(uuid)
      .then(setPin)
      .catch(() =>
        setSimpleToasts({
          type: 'danger',
          message: 'Failed to reveal access code',
          show: true,
        }),
      )
      .finally(() => setLoading(false));
  }, [show, uuid, accessCodes, setSimpleToasts]);

  const copy = () => {
    navigator.clipboard?.writeText(pin);
    setSimpleToasts({ type: 'success', message: 'Copied to clipboard', show: true });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Access code</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {loading ? <Spinner animation="border" /> : <h2 className="m-0">{pin || '—'}</h2>}
      </Modal.Body>
      <Modal.Footer>
        <Button className="cancel-button" onClick={handleClose}>
          Close
        </Button>
        <Button className="save-button" onClick={copy} disabled={!pin}>
          Copy
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
